import { render } from "./OrderDetails.vue?vue&type=template&id=97c3b3f6"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
script.render = render

export default script